import { useEffect, useState } from 'react';

const useScript = (src: string, onLoad: () => void) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = src;
    script.type = 'text/javascript';
    script.async = true;
    script.onload = () => {
      setLoaded(true);
      onLoad();
    };
    document.body.appendChild(script);

    return () => {
      if ((window as any).fastlink?.close) {
        (window as any).fastlink.close();
        console.log('FastLink instance closed during script cleanup.');
      }
      document.body.removeChild(script);
    };
  }, [src, onLoad]);

  return loaded;
};

export default useScript;
